import React from "react";
import PropTypes from "prop-types";
import ChatIcon from "../resources/chat.svg";
import CloseIcon from "../resources/CloseFilled.svg";

const ChatButton = props => {
  return /*#__PURE__*/React.createElement("button", {
    onClick: props.isChatPanelOpen ? props.onCloseClick : props.onOpenClick,
    className: "chat-button"
  }, props.isChatPanelOpen ? /*#__PURE__*/React.createElement("img", {
    alt: "Minimize Chat",
    src: CloseIcon
  }) : /*#__PURE__*/React.createElement("img", {
    alt: "Maximize Chat",
    src: ChatIcon
  }));
};

ChatButton.propTypes = {
  isChatPanelOpen: PropTypes.bool,
  onOpenClick: PropTypes.func,
  onCloseClick: PropTypes.func
};
export default ChatButton;